import { app, Component, ojs } from "modular-openscriptjs";
import MpesaForm from "./MpesaForm";

const h = app("h");

ojs(MpesaForm);

export default class PaymentForm extends Component {
	render(method, ...args) {
		let m = method.value;

		switch (m) {
			case "mpesa":
				return this.mpesa(...args);
			case "capa":
				return this.capa(...args);
			case "offlineMpesa":
				return this.offlineMpesa(...args);
			default:
				return this.mpesa(...args);
		}
	}

	mpesa(...args) {
		return h.MpesaForm(...args);
	}

	capa(...args) {
		return h.CapaForm(...args);
	}

	offlineMpesa(...args) {
		return h.OfflineMpesaForm(...args);
	}
}

ojs(PaymentForm);
